import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../lib/content";

export const CompanyIntro = () => (
  <section id="about" data-testid="company-intro" className="relative bg-ivory text-navy py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-7">
          <Reveal>
            <Overline dark>Chapter 01 — The Company</Overline>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-balance">
              Building Businesses.<br />Creating Value.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-lg lg:text-xl leading-relaxed text-navy/70 max-w-2xl">
              KRV Nexus Pvt Ltd is an emerging multi-business organization built around a simple philosophy: identify meaningful opportunities, build strong brands, and create lasting value.
            </p>
            <p className="mt-6 text-base lg:text-lg leading-relaxed text-navy/60 max-w-2xl">
              Our approach combines disciplined execution, customer-focused businesses, technology, knowledge, and long-term thinking to build ventures that can grow independently while remaining connected through a common vision.
            </p>
            <a href="#businesses" data-testid="intro-cta" className="mt-10 inline-flex items-center gap-2 text-navy font-medium link-underline group">
              Learn About KRV Nexus
              <ArrowUpRight size={18} className="text-gold-deep group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.15} className="relative">
            <div className="overflow-hidden">
              <img src={IMAGES.architecture} alt="Structured corporate architecture" className="w-full h-[420px] lg:h-[520px] object-cover" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-navy text-ivory p-6 max-w-[220px] hidden sm:block">
              <p className="font-serif text-3xl text-gold">02</p>
              <p className="text-sm text-ivory/70 mt-1">Verticals under one connected vision</p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
